export default "__VITE_ASSET__0Kv9uFDx__"